import { Navbar } from "../../components/Navbar/Navbar"
import { SessionExpiredCard } from "../../components/SessionExpiredCard"
import Report from "../../components/TableContentReport"
import { validateToken } from "../../services/AuthService"
import { useState, useEffect, useRef } from "react"
import { useNavigate } from "react-router-dom"


const DashboardReport = () => {
    const token = localStorage.getItem("site")
    const navigate = useNavigate()
    const timeoutRef = useRef()
    const [isValidate, setIsValidate] = useState(false)

    useEffect(()=> {
        validateToken(token)
            .then((response) => {
                if (response.status === 200) setIsValidate(true)
            })
            .catch((err)=>{
                if (err.response.status) {
                    setIsValidate(false)
                    timeoutRef.current = setTimeout(() => {
                        navigate("/login")
                    },4000)
                }
            })
    },[])

    useEffect(() => {
        return () => {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
        };
    }, []);
    return (
        <>
            {isValidate && (
                <>
                    <Navbar />
                    <Report />
                </>
            )}
            {!isValidate && (
                <SessionExpiredCard />
            )}
        </>
    )
}

export default DashboardReport